import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconHome.tsx
const OutlinedFilledHome = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M135-95v-517.67L480-872l346 259v518H566v-311H394v311H135Z" })
});
const OutlinedHome = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M229-189h124v-258h254v258h124v-377L480-754 229-565.67V-189Zm-94 94v-518l345-259 346 259v518H524v-269h-88v269H135Zm345-377Z" })
});
const RoundedFilledHome = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M135-189v-377q0-22.25 9.38-42 9.37-19.75 27.62-33l251-189q24.68-19 56.84-19Q512-849 537-830l251 189q18.25 13.25 28.13 33 9.87 19.75 9.87 42v377q0 39.75-27.62 66.87Q770.75-95 731-95H613q-19.75 0-33.37-13.63Q566-122.25 566-142v-217q0-19.75-13.62-33.38Q538.75-406 519-406h-78q-19.75 0-33.37 13.62Q394-378.75 394-359v217q0 19.75-13.62 33.37Q366.75-95 347-95H229q-39.75 0-66.87-27.13Q135-149.25 135-189Z" })
});
const RoundedHome = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M229-189h124v-211q0-19.75 13.63-33.38Q380.25-447 400-447h160q19.75 0 33.38 13.62Q607-419.75 607-400v211h124v-376.67L480-754 229-565.67V-189Zm-94 0v-377q0-22.04 9.55-41.75Q154.09-627.47 172-641l251-189q24.68-19 56.84-19Q512-849 537-830l251 189q18.38 13.53 28.19 33.25Q826-588.04 826-566v377q0 39.8-27.39 66.9Q771.21-95 731-95H571q-19.75 0-33.37-13.63Q524-122.25 524-142v-222h-88v222q0 19.75-13.62 33.37Q408.75-95 389-95H229q-39.8 0-66.9-27.1Q135-149.2 135-189Zm345-283Z" })
});
const SharpFilledHome = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M135-95v-517.67L480-872l346 259v518H566v-311H394v311H135Z" })
});
const SharpHome = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M229-189h124v-258h254v258h124v-377L480-754 229-565.67V-189Zm-94 94v-518l345-259 346 259v518H524v-269h-88v269H135Zm345-377Z" })
});
const componentMap = {
	outlined: OutlinedHome,
	"outlined-fill": OutlinedFilledHome,
	rounded: RoundedHome,
	"rounded-fill": RoundedFilledHome,
	sharp: SharpHome,
	"sharp-fill": SharpFilledHome
};
const IconHome = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconHome };